import { useState } from 'react';
import { Helmet } from 'react-helmet';
import ui from 'stores/ui';
import { PlatformSectionConfig } from 'modules/Platform/config';
import AppLink from 'modules/Platform/components/AppLink';
import { tryDownload } from './util';
import './style.scss';

const Dlapp: React.FC = () => {
    function tryDownloadApp() {
        if (ui.isIOS) {
            tryDownload('ios');
        }

        if (ui.isAndroid) {
            tryDownload('android');
        }
    }

    const [platformConfig] = useState(() => {
        tryDownloadApp();

        return PlatformSectionConfig.header.appLink.filter(t => ['ios', 'android'].includes(t.type));
    });

    return (
        <section className="dlapp-root">
            <Helmet>
                <title>Cutting Edge Stock Trading Platforms by TradeUP</title>
                <meta
                    name="description"
                    content="TradeUP's online trading platform provides a wide array of tools and resources for you to trade with ease. You can keep tabs on the market, place orders, and monitor your positions all in one place!"
                />
            </Helmet>
            <header className="platform-header">
                <div className="flex-1"></div>
                <div className="header-content">
                    <div>Invest Anywhere Anytime </div>
                    <div className="header-content-long">
                        <span>We’re Adding More Value to </span>
                        <span>$0 Commission </span>
                    </div>
                </div>
                <div className="applink-container">
                    {platformConfig.map(item => {
                        const { type, imgSrc, url } = item;

                        return <AppLink key={type} type={type} imgSrc={imgSrc} url={url} className="applink-item" />;
                    })}
                </div>
            </header>
        </section>
    );
};

export default Dlapp;
